import React, { useState } from 'react';
import { Container, Row, Col, Form, FormGroup, Label, Input } from 'reactstrap';
import bgImage from '../../../assets/images/talk.jpeg';

const ContactUsSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate sending data or just UI feedback
    console.log('Form data submitted:', formData);
    alert('Mensagem enviada com sucesso! Entraremos em contato em breve.');
    setFormData({ name: '', phone: '', email: '' });
  };

  return (
    <div id="fale-conosco" style={{ 
      position: 'relative', 
      minHeight: '80vh', 
      backgroundImage: `url(${bgImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'top center',
      backgroundAttachment: 'fixed',
      display: 'flex',
      alignItems: 'stretch',
      overflow: 'hidden'
    }}>
      {/* Dark Overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(26, 29, 36, 0.55)',
        zIndex: 1
      }}></div>

      <Container fluid className="px-0 px-md-4 px-xl-5 position-relative w-100" style={{ zIndex: 2, display: 'flex' }}>
        <Row className="m-0 w-100 align-items-stretch">
          
          <Col lg={7} xl={5} className="p-0 d-flex flex-column">
            <div 
              style={{ 
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                backgroundColor: 'rgba(32, 38, 52, 0.5)', 
                backdropFilter: 'blur(12px)',
                border: 'none',
                padding: 'clamp(30px, 5vw, 100px) clamp(15px, 4vw, 80px)',
                boxShadow: '0 0 120px rgba(0, 0, 0, 0.5), 0 0 80px rgba(0, 243, 255, 0.08)',
                animation: 'fadeInLeft 1s ease-out'
              }}
            >
              <div style={{ position: 'relative', marginBottom: '2.5rem', zIndex: 1 }}>
                
                {/* Texto Gigante de Fundo (Sombra Outline Animada) */}
                <div 
                  className="position-absolute text-uppercase"
                  style={{
                    fontSize: 'clamp(5rem, 14vw, 12rem)', 
                    fontWeight: 'bold',
                    color: 'transparent',
                    WebkitTextStroke: '2px rgba(0, 243, 255, 0.15)', 
                    top: '25%',
                    left: '-20px', 
                    zIndex: -1,
                    pointerEvents: 'none',
                    userSelect: 'none',
                    letterSpacing: '8px',
                    whiteSpace: 'nowrap',
                    animation: 'floatingShadowContact 8s ease-in-out infinite alternate',
                    transform: 'translateY(-50%)'
                  }}
                >
                  FALE
                </div>

                <h2 className="mb-2 text-uppercase position-relative" style={{ fontSize: 'clamp(2rem, 5vw, 4rem)', fontWeight: 'bold', color: '#ffffff', textShadow: '0 2px 10px rgba(0,243,255,0.3)', letterSpacing: '-0.5px' }}>
                  Fale Conosco
                </h2>
                
                <div className="d-flex position-relative mt-4" style={{ zIndex: 1 }}>
                  <div 
                    style={{
                      width: '4px',
                      backgroundColor: '#00f3ff',
                      boxShadow: '0 0 8px #00f3ff, 0 0 15px rgba(0, 243, 255, 0.6)',
                      borderRadius: '2px',
                      marginRight: '15px',
                      flexShrink: 0
                    }}
                  ></div>
                  <p className="mb-0" style={{ color: '#a6b0cf', fontSize: 'clamp(1rem, 1.2vw, 1.2rem)', lineHeight: '1.6' }}>
                    Transforme a gestão da sua academia hoje mesmo. Preencha seus dados e nossa equipe entrará em contato.
                  </p>
                </div>
              </div>

              <Form onSubmit={handleSubmit} style={{ maxWidth: '600px' }}>
                <FormGroup className="mb-4">
                  <Label for="contactName" style={{ color: '#00f3ff', fontSize: '0.95rem', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '1px' }}>Nome Completo</Label>
                  <Input 
                    type="text" 
                    name="name" 
                    id="contactName" 
                    placeholder="Seu nome"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    style={{
                      backgroundColor: 'rgba(26, 29, 36, 0.6)',
                      border: '1px solid rgba(255, 255, 255, 0.1)',
                      color: '#fff',
                      borderRadius: '12px',
                      padding: '16px 20px',
                      fontSize: '1.05rem',
                      boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.5)',
                      transition: 'all 0.3s ease'
                    }}
                    className="contact-input"
                  />
                </FormGroup>

                <FormGroup className="mb-4">
                  <Label for="contactPhone" style={{ color: '#00f3ff', fontSize: '0.95rem', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '1px' }}>Telefone / WhatsApp</Label>
                  <Input 
                    type="tel" 
                    name="phone" 
                    id="contactPhone" 
                    placeholder="(00) 00000-0000"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    style={{
                      backgroundColor: 'rgba(26, 29, 36, 0.6)',
                      border: '1px solid rgba(255, 255, 255, 0.1)',
                      color: '#fff',
                      borderRadius: '12px',
                      padding: '16px 20px',
                      fontSize: '1.05rem',
                      boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.5)',
                      transition: 'all 0.3s ease'
                    }}
                    className="contact-input"
                  />
                </FormGroup>

                <FormGroup className="mb-5">
                  <Label for="contactEmail" style={{ color: '#00f3ff', fontSize: '0.95rem', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '1px' }}>E-mail</Label>
                  <Input 
                    type="email" 
                    name="email" 
                    id="contactEmail" 
                    placeholder="seu@email.com.br"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    style={{
                      backgroundColor: 'rgba(26, 29, 36, 0.6)',
                      border: '1px solid rgba(255, 255, 255, 0.1)',
                      color: '#fff',
                      borderRadius: '12px',
                      padding: '16px 20px',
                      fontSize: '1.05rem',
                      boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.5)',
                      transition: 'all 0.3s ease'
                    }}
                    className="contact-input"
                  />
                </FormGroup>

                <button 
                  type="submit" 
                  className="w-100"
                  style={{
                    backgroundColor: 'transparent',
                    border: '1px solid #00f3ff',
                    color: '#00f3ff',
                    padding: '18px 30px',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    borderRadius: '12px',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 0 15px rgba(0, 243, 255, 0.3), inset 0 0 10px rgba(0, 243, 255, 0.1)'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = 'rgba(0, 243, 255, 0.1)';
                    e.target.style.boxShadow = '0 0 25px rgba(0, 243, 255, 0.5), inset 0 0 15px rgba(0, 243, 255, 0.2)';
                    e.target.style.transform = 'translateY(-2px)';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = 'transparent';
                    e.target.style.boxShadow = '0 0 15px rgba(0, 243, 255, 0.3), inset 0 0 10px rgba(0, 243, 255, 0.1)';
                    e.target.style.transform = 'translateY(0)';
                  }}
                >
                  Enviar Mensagem
                </button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>

      <style>
        {`
          .contact-input:focus {
            outline: none !important;
            border-color: #00f3ff !important;
            box-shadow: 0 0 15px rgba(0, 243, 255, 0.3), inset 0 2px 4px rgba(0,0,0,0.5) !important;
          }
          .contact-input::placeholder {
            color: rgba(255, 255, 255, 0.3) !important;
          }
          @keyframes fadeInLeft {
            from { transform: translateX(-40px); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
          }
          @keyframes floatingShadowContact {
            from { transform: translateY(-50%) translateX(0px); }
            to { transform: translateY(-50%) translateX(-15px); }
          }
        `}
      </style>
    </div>
  );
};

export default ContactUsSection;
